angular.module('bookAndPay').controller('NewCartCtrl', ["$scope", "$state", "$http", "Restangular", "$stateParams", "DataService", "newCart", function($scope, $state, $http, Restangular, $stateParams, DataService, newCart) {
  var Carts, nextStep;
  $scope.newCart = newCart.plain();
  $scope.message = $stateParams.flash;
  $scope.user = {
    cart_type: $scope.newCart.cart_type,
    contact_email: $stateParams.ce || '',
    event_id: $stateParams.eid ? +$stateParams.eid : void 0
  };
  Carts = Restangular.one('offers', $stateParams.uuid).all('carts');
  $scope.params = {};
  $scope.isPaymentOnly = $scope.newCart.cart_type === 'payment_only_cart';
  nextStep = function(cartId) {
    if ($scope.isPaymentOnly || $scope.user.event_id) {
      return $state.go('bookAndPay.editCart', {
        uuid: cartId,
        ct: $stateParams.ct
      });
    } else {
      return $state.go('bookAndPay.showEvents', {
        uuid: cartId
      });
    }
  };
  $scope.submit = function() {
    $scope.isLoading = true;
    return Carts.post($scope.user).then(function(cart) {
      $scope.isLoading = false;
      $scope.cart = cart;
      if (cart.matching_contacts.length < 2) {
        return nextStep(cart.cart_uuid);
      }
    }, function() {
      return $scope.isLoading = false;
    });
  };
  return $scope.selectContact = function(id) {
    var url;
    url = `/websites/${DataService.domain}/book_and_pay/carts/${$scope.cart.cart_uuid}`;
    $scope.cart.contact_id = id;
    return $http.put(url, {
      cart: $scope.cart
    }).then(function(response) {
      return nextStep(response.data.cart_uuid);
    });
  };
}]);
